'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const HosStatusDurations=require('../../../dist-es6/client/dtos/hosStatusDurations');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');let

StatisticsService=class StatisticsService extends BaseService{
static get $inject(){return['socketService','userService']}

constructor(socketService,userService){
super();
this._socketService=socketService;
this._userService=userService;
}

async getPersonalStatisticsFor(personInfo,queryInterval,timezone){
const fatigueMeterType=_.get(this._userService,'currentUser.fatigueMeterType');

let statisticsRequest={
personInfo,
queryInterval,
timezone,
requestedStats:[
'lastKnownStatus',
'dailyFatigueSummaries',
'dailyStatusSummaries',
'dutyHours']};



if(fatigueMeterType===FatigueMeterType.Trucking){
_.pushMany(statisticsRequest.requestedStats,['numTripsOnDuty','timeOfLastHosStatus']);
}

if(fatigueMeterType===FatigueMeterType.Workforce){
_.pushMany(statisticsRequest.requestedStats,['numDuties']);
}

let personalStatistics=await this._socketService.sendAndWaitForResponse('GetPersonalStatistics',statisticsRequest);

personalStatistics.queryInterval=new TimeInterval(personalStatistics.queryInterval);
personalStatistics.timeOfLastHosStatus=SocketResponse.safeDeserializeDate(personalStatistics.timeOfLastHosStatus);

if(_.exists(personalStatistics.dailyStatusSummaries)){
let hasDrivingOffDutyDay=!1;
personalStatistics.dailyStatusSummaries=personalStatistics.dailyStatusSummaries.map(statusSummary=>{
const durations=HosStatusDurations.fromJSON(statusSummary);
if(durations.drivingOffDuty.totalMilliseconds()>0){
hasDrivingOffDutyDay=!0;
}
return{
onDuty:durations.onDuty,
offDuty:timespan.fromMilliseconds(durations.offDuty.totalMilliseconds()+durations.drivingOffDuty.totalMilliseconds()),
drivingOffDuty:durations.drivingOffDuty,
driving:durations.driving,
sleeperBerth:durations.sleeperBerth,
onDutyOrDriving:timespan.fromMilliseconds(durations.onDuty.totalMilliseconds()+durations.driving.totalMilliseconds())};

});
personalStatistics.dailyStatusSummaries.hasDrivingOffDutyDay=hasDrivingOffDutyDay;
}

return personalStatistics;
}};


module.exports=StatisticsService;
//# sourceMappingURL=statisticsService.js.map
